export interface Rating {
  qualification: string;
}
